import React, { useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import Input from "antd/es/input/Input";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import Table from "../../../../components/Datatable/DataTable";
import config from "../../../../config/config";
import Loader from "../../../../components/Loader/Loader";
import DeleteConfirmationModal from "../../../../components/Modal/UnDeleteConfirmation";
import { Link } from "react-router-dom";
import MaterialReactTable from "material-react-table";
import { Box, Button } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';

const DeletedCustomers = (props) => {
  let selectData = [];
  const token = localStorage.getItem("Token");
  const [perPageSize, setperPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  // const [selectedData, setSelectedData] = useState([]);
  const [sortingId, setSortingId] = useState(1);
  const [sortingDirection, setSortingDirection] = useState("asc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [data, setData] = useState([]);
  const [selectedCustomerCheckboxIds, setselectedCustomerCheckboxIds] =
    useState("");

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const [deleteModalOpen,setDeleteModalOpen]=useState(false)

  // const handleRowSelected = (e) => {
  //   if (e.selectedRows.length > 0) {
  //     setSelectedRows(e.selectedRows.map((x) => x.Id));
  //     selectData[currentPage] = e.selectedRows.map((x) => x.Id);
  //     console.log(e.selectedRows.map((x) => x.Id));

  //     const selectedCustomerCheckboxIds =
  //       selectData.length > 0 ? selectData[currentPage].toString() : "";
  //     setselectedCustomerCheckboxIds(selectedCustomerCheckboxIds);
  //     console.log(selectedCustomerCheckboxIds);
  //   }
  // };

  // Get all tag data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    columnFilters,
    globalFilter,
    pagination,
    sorting
  ) => {
    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    const columnIndex = columns.findIndex(
      (column) => column.accessorKey === sorting[0]?.id
    );

    setLoading(true);
    axios
      .get(
        `${
          config.customersBaseUrl
        }/customers/managedelete?filtercolumnsearchtext=${FilterColumnSearchText}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res.data.ResponseData, "responsedata==>");
        setData(res.data.ResponseData);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setRowCount(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  console.log(data, "data2345==>");

  useEffect(() => {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
  }, [globalFilter, pagination, sorting]);

  const handleDeletePopup = (id,rows, field) => {
    // console.log(id, rows.map((el)=>el.original),field, "id===>");

    const data=rows.map((el) => el.original.Id).join(",")
    // console.log(rows, field, "rows==>");
    const deleteRequestParam = {
      undeletecustomersids: data,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    setDeleteModalOpen(true)
  };

  const contextActions = useMemo(() => {
    return (
      <button
        type="button"
        className="btn btn-success btn-sm pull-left "
        data-bs-toggle="modal"
        data-bs-target="#UnDeleteConfirmationModal"
        onClick={handleDeletePopup}
      >
        <i className="fa fa-trash fa-sm" /> Un Delete
      </button>
    );
  }, [data, selectedRows, toggleCleared]);

  // Table Data
  // const columns = [
  //   {
  //     name: "ID",
  //     selector: "Id",
  //     sortable: true,
  //   },
  //   {
  //     name: "Name",
  //     selector: (row) => row.FirstName + " " + row.LastName,
  //     sortable: true,
  //   },
  //   {
  //     name: "E-Mail",
  //     selector: "Email",
  //     sortable: true,
  //   },
  //   {
  //     name: "Phone Number",
  //     selector: "PhoneNumber",
  //     sortable: true,
  //   },
  // ];

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "Id",
    },
    {
      header: "Name",
      accessorKey: "FirstName",
      Cell: ({ row }) => row.original.FirstName + " " + row.original.LastName,
    },
    {
      header: "E-Mail",
      accessorKey: "Email",
      // Cell: ({ row }) => parseFloat(row.original.Balance).toFixed(2),
    },
    {
      header: "Phone Number",
      accessorKey: "PhoneNumber",
      // Cell: ({ row }) => parseFloat(row.original.Balance).toFixed(2),
    },
  ]);

  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(page, perPageSize, searchtext, sortingId, sortingDirection);
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(1, perPageSize, searchtext, e.id, sortingDirection);
  };
  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPageSize, e.target.value, sortingId, sortingDirection);
    console.log(handleListData);
  };
  // const rowSelectCritera = row => row.fat > 6;

  // const clickHandler = (e) => {
  //     console.log(e.target.id);
  // }
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            {/* <div className="page-title">
              <h3>Deleted Customers</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/customers">Customers List</Link>
                </li>
                <li className="breadcrumb-item active">
                  Deleted Customers List
                </li>
              </ul>
            </div> */}
            <div className="row" style={{ marginTop: "5px" }}>
              {/* <div className="col"> */}
              <h3 className="page-title">Deleted Customers</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item "> <Link to="/customers">Customers List</Link></li>
                <li className="breadcrumb-item active">
                  Deleted Customers List
                </li>
              </ul>
              {/* </div> */}
            </div>
          </div>

          {/* <div className="row flex-row-reverse">
            <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
              <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm w-50 pull-right"
                onChange={ChangeFilterText}
                value={searchtext}
              />
              {/* <Input.Search placeholder="Search..." className="search-btn form-control form-control-sm" onChange={ChangeFilterText} /> */}
          {/* </div>
          </div>  */}

          {/* Customer list */}
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                {/* <DataTable
                  title="Deleted Customer List"
                  columns={columns}
                  data={data}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={(e) => {
                    handlePerRowsChange(1, e);
                  }}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  responsive
                  paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                  persistTableHead
                  selectableRows
                  sortServer
                  onSort={handleSort}
                  contextActions={contextActions}
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                /> */}
                <MaterialReactTable
                  columns={columns}
                  //  title="Deleted Customer List"
                  data={data}
                  // positionPagination='top'
                  enableColumnResizing
                  enableGrouping
                  enableStickyHeader
                  enableStickyFooter
                  enableRowSelection
                  enableColumnOrdering
                  // enableRowActions

                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "1rem",
                        p: "0.5rem",
                        flexWrap: "wrap",
                      }}
                    >
                    {console.log(table,"tables")}

                      <Button
                        size="small"
                        disabled={
                          !table.getIsSomeRowsSelected() &&
                          !table.getIsAllRowsSelected()
                        }
                        //only export selected rows
                        // data-bs-toggle="modal"
                        // data-bs-target="#UnDeleteConfirmationModal"
                        onClick={() => handleDeletePopup("", table.getSelectedRowModel().rows, "multipleRowInactive")}
                        startIcon={<DeleteIcon />}
                        variant="contained"
                      >
                        UnDelete
                      </Button>
                      {/* <Button
                        size="small"
                        onClick={() =>
                          // setPagination({ ...pagination, pageSize: totalRows })
                          setPagination({ ...pagination, pageIndex: 0, pageSize: totalRows })
                        }
                        variant="contained"
                      >
                        Get All Data
                      </Button> */}
                    </Box>
                  )}
                  // rowVirtualizerProps={{
                  //   overscan: 10, //adjust the number or rows that are rendered above and below the visible area of the table
                  //   estimateSize: () => 100, //if your rows are taller than normal, try tweaking this value to make scrollbar size more accurate
                  // }}
                  muiTableContainerProps={{
                    sx: { maxHeight: "fit-content" },
                  }}
                  initialState={{
                    density: "compact",
                    expanded: true, //expand all groups by default
                    // grouping: [""], //an array of columns to group by by default (can be multiple)
                    pagination: { pageIndex: 0, pageSize: 10 },
                    // sorting: { id: "Name", desc: false }, //sort by state by default
                  }}
                  muiTablePaginationProps={{
                    rowsPerPageOptions: [10, 25, 50, 100, 300],
                  }}
                  manualPagination
                  manualSorting
                  muiToolbarAlertBannerProps={
                    isError
                      ? {
                          color: "error",
                          children: "Error loading data",
                        }
                      : undefined
                  }
                  // onColumnFiltersChange={setColumnFilters} // for termp comment filteron column
                  onGlobalFilterChange={setGlobalFilter}
                  onPaginationChange={setPagination}
                  onSortingChange={setSorting}
                  rowCount={rowCount}
                  // enableColumnVirtualization={false}
                  // enableColumnVirtualization
                  state={{
                    // columnFilters, // for termp comment filteron column
                    globalFilter,
                    isLoading,
                    pagination,
                    showAlertBanner: isError,
                    showProgressBars: isRefetching,
                    sorting,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <DeleteConfirmationModal
        deleteApiUrl={`${config.customersBaseUrl}/customers/undeletecustomer`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
    </>
  );
};

export default DeletedCustomers;
